<script setup>
defineProps({
    status: {
        type: [Object, String],
        required: true,
    },
    link: {
        type: String,
    }
})        
</script>
<template>
    <div>
        <router-link class="no-underline" :to="link ? link : ''">
            <button :class="status?.includes('Triagem pendente') ||
                status?.includes('Selecionar parecerista') ||
                status?.includes('Aguardando classificação') ||
                status?.includes('Especialidade rejeitada')
                ? 'tag red'
                : status?.includes('Rejeitada') || status?.includes('Descontinuado')
                    ? 'tag disabled'
                    : status?.includes('Aguardando parecer') || status?.includes('Plano de trabalho') || status?.includes('Relatório final')
                        ? 'tag yellow'
                        : status?.includes('Classificada')
                            ? 'tag blue'
                            : status?.includes('Selecionado')
                                ? 'tag green'
                                : ''
                ">
                {{ status }}
            </button>
        </router-link>
    </div>
</template>